import React from 'react';
import SkylineRoleDropdown, {SkylineRoleDropdownComponentProps, SkylineRoleDropdownQuery} from './SkylineRoleDropdown';
import {ForecastQueryRenderer} from '../../../../../../ForecastQueryRenderer';

type SkylineRoleDropdownRelayProps = {projectId?: string; warningText?: string} & SkylineRoleDropdownComponentProps;

const SkylineRoleDropdownRelayWrapper = ({
	role,
	onSelect,
	controlled,
	projectId,
}: SkylineRoleDropdownRelayProps): JSX.Element => {
	return (
		<ForecastQueryRenderer
			key="query-render-skyline-role-dropdown"
			query={SkylineRoleDropdownQuery}
			variables={{projectId: projectId}}
			render={relayProps => {
				return (
					<SkylineRoleDropdown
						{...relayProps}
						role={role}
						onSelect={onSelect}
						controlled={controlled}
						projectId={projectId}
					/>
				);
			}}
		/>
	);
};

export default SkylineRoleDropdownRelayWrapper;
